export default class MethodInfo {
  constructor(options: {
    MethodUrl: string;
    MethodType?: string;
    ContentType?: string;
  }) {
    this.MethodUrl = options.MethodUrl;
    this.MethodType = options.MethodType;
    this.ContentType = options.ContentType;
  }

  public MethodUrl: string;
  public MethodType: string | undefined = undefined;
  public ContentType: string | undefined = undefined;
}
